$(document).ready(function () {
  console.log('xxxxxxx')
$(document).on('click','.coupon-view-more-button',function(){  
  console.log('second')
  $('.ticket-coupon-section.hidden-discount-code').show();
  $(this).removeClass('coupon-view-more-button');
  $(this).addClass('coupon-view-less-button');
  $(this).html('View Less Coupons >')
})
$(document).on('click','.coupon-view-less-button',function(){
  console.log('one')
  $('.ticket-coupon-section.hidden-discount-code').hide();
  $(this).removeClass('coupon-view-less-button');
  $(this).addClass('coupon-view-more-button');
  $(this).html('View More Coupons >')
})

$(document).on('click','.coupon-apply',function(){  
    var textToCopy = $(this).attr('data-coupen-code'); // Fix typo: "data-coupen-code" -> "data-coupon-code" if needed
    if (textToCopy) {
        navigator.clipboard.writeText(textToCopy)
    }
});

  $(".sc-before-after-image-wrapper").slick({
dots: false,
arrows: false,
infinite: false,
slidesToShow: 1,
slidesToScroll: 1
});

  $('.accordion-title').on('click', function() {
    var $button = $(this);
    var $content = $button.next('.accordion-content');
    var isExpanded = $button.attr('aria-expanded') === 'true';
    var willExpand = !isExpanded;

    // Close sibling accordion items first so only one stays open.
    var $accordionRoot = $button.closest('.pdp-v2-tabs, .accordion');
    var $otherButtons = $accordionRoot.length ? $accordionRoot.find('.accordion-title').not($button) : $('.accordion-title').not($button);
    var $otherContents = $accordionRoot.length ? $accordionRoot.find('.accordion-content').not($content) : $('.accordion-content').not($content);

    $otherButtons.attr('aria-expanded', 'false').removeClass('active');
    $otherContents.stop(true, true).slideUp(300);

    $button.attr('aria-expanded', willExpand ? 'true' : 'false').toggleClass('active', willExpand);
    $content.stop(true, true)[willExpand ? 'slideDown' : 'slideUp'](300);
  });

  function setupDesktopStackedPdpMedia() {
    if (window.matchMedia('(max-width: 999px)').matches) {
      return;
    }

    var mediaRoots = document.querySelectorAll('.template--product-new-design #main-product-v2 product-media');
    mediaRoots.forEach(function(mediaRoot) {
      var carousel = mediaRoot.querySelector('flickity-carousel.product__media-list');
      if (!carousel || carousel.dataset.desktopStackedReady === 'true') {
        return;
      }

      carousel.dataset.desktopStackedReady = 'true';

      function cleanupCarouselDom() {
        var viewport = carousel.querySelector('.flickity-viewport');
        var slider = viewport ? viewport.querySelector('.flickity-slider') : null;

        if (slider) {
          while (slider.firstChild) {
            carousel.appendChild(slider.firstChild);
          }
        }

        if (viewport && viewport.parentNode) {
          viewport.parentNode.removeChild(viewport);
        }

        carousel.classList.remove('flickity-enabled', 'is-draggable', 'is-fade', 'flickity-rtl');
        carousel.removeAttribute('style');

        carousel.querySelectorAll('.product__media-item').forEach(function(item) {
          item.removeAttribute('style');
          item.classList.remove('is-selected');
        });
      }

      if (carousel.flickityInstance && typeof carousel.flickityInstance.then === 'function') {
        carousel.flickityInstance.then(function(instance) {
          try {
            if (instance && typeof instance.destroy === 'function') {
              instance.destroy();
            }
          } catch (e) {
            // no-op
          }
          cleanupCarouselDom();
        });
      } else {
        cleanupCarouselDom();
      }
    });
  }

  setupDesktopStackedPdpMedia();
  document.addEventListener('shopify:section:load', setupDesktopStackedPdpMedia);

})

